module.exports = __webpack_public_path__ + "static/media/money.92836478.svg";